/**
 * @copyright 2025 Cooltrax Pty Ltd. All rights reserved.
 */

import React, { ReactNode } from 'react'

import { useApi } from '@/hooks'
import type { AlarmCode } from '@/types/dashboard-types'
import logger from '@/utils/logger'

import { AlarmCodeContext } from './AlarmCodeContext'

const log = logger({ category: 'AlarmCodeProvider' })

export const AlarmCodeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { api } = useApi()
  const [codes, setCodes] = React.useState<AlarmCode[]>([])

  React.useEffect(() => {
    if (!api) {
      return
    }
    const fn = async () => {
      try {
        log.debug('Loading alarm codes')
        const response = await api.get<AlarmCode[]>({
          path: '/fridge-alarm-codes?skip=0&take=5000',
          origin: 'AlarmCodeProvider',
          expiresIn: 'session',
        })
        log.debug('alarm code response: %o', response)
        if (response.error) {
          setCodes([])
        } else {
          setCodes((response.data || []).sort((a, b) => a.description.trim().localeCompare(b.description.trim())))
        }
      } catch (ex) {
        log.error('%o', ex)
        setCodes([])
      }
    }
    fn()
  }, [])

  return <AlarmCodeContext.Provider value={codes}>{children}</AlarmCodeContext.Provider>
}
